export default () => ({
  accountList: [],
  accountFilterList: [],
  account: null,
});
